import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source"];

  connect() {
    this.toggle();
  }

  toggle() {
    const values = this.sourceTargets.map(target => {
      if (target.type === 'radio') {
        return target.checked ? target.value : null;
      }

      return target.value;
    }).filter(value => value !== null);

    const elements = this.element.querySelectorAll("[data-show]");

    elements.forEach((el) => {
      const showValues = el.dataset.show ? el.dataset.show.split(" ") : [];
      el.classList.toggle("d-none", !values.some(value => showValues.includes(value)));
    });
  }
}
